export default {
  title: 'การบริหารจัดการวันลาออนไลน์',
  'acting-for': {
    label: 'ทำรายการแทน',
    self: 'ตัวเอง',
    'missing-request-permission':
      'คุณไม่มีสิทธิ์ขอลา กรุณาติดต่อผู้ดูแลระบบเพื่อเพิ่มสิทธิ์ LEAVE_REQ',
    'missing-approve-permission':
      'คุณไม่มีสิทธิ์อนุมัติการลา กรุณาติดต่อผู้ดูแลระบบเพื่อเพิ่มสิทธิ์ LEAVE_APP'
  },
  tabs: {
    'my-leave': 'วันลาของฉัน',
    history: 'ประวัติสถานะรายการ',
    approve: 'อนุมัติการลา',
    'approver-calendar': 'ปฏิทินผู้อนุมัติ'
  },
  'my-leave': {
    'loading-state': {
      loading: 'กำลังอัปเดตข้อมูล…',
      entitlementFailed:
        'โหลดสิทธิ์การลาไม่สำเร็จ ยอดเดิมที่แสดงยังไม่ได้อัปเดต',
      calendarFailed: 'โหลดปฏิทินไม่สำเร็จ รายการเดิมที่แสดงยังไม่ได้อัปเดต',
      retry: 'ลองใหม่'
    },
    buttons: {
      report: 'รายงาน',
      approval: 'การอนุมัติ',
      calendar: 'ปฏิทินของผู้อนุมัติ',
      delegate: 'มอบหมายการอนุมัติ',
      request: 'ขอลา'
    },
    'my-entitlement-form': {
      title: 'สิทธิ์',
      'entitlement-type': {
        annualLeave: 'Annual Leave',
        carryForward: 'ยอดยกมา',
        sickLeave: 'Sick Leave',
        businessLeave: 'Business Leave',
        otherLeave: 'Other Leave'
      },
      words: {
        total: 'ยอดรวม',
        days: 'วัน',
        entitlement: 'สิทธิ์',
        used: 'ใช้ไป',
        balance: 'คงเหลือ',
        pending: 'รอการอนุมัติ'
      }
    },
    'my-leave-form': {
      title: 'วันลาของฉัน',
      'half-day-morning': 'ครึ่งวันแรก',
      'half-day-afternoon': 'ครึ่งวันหลัง',
      hourly: 'รายชั่วโมง'
    },
    'leave-request-form': {
      dates: {
        selectLeaveType: 'กรุณาเลือกประเภทลาที่พนักงานรายนี้มีสิทธิ์',
        loading: 'กำลังโหลดเงื่อนไขการลาและปฏิทินกะของพนักงาน…',
        scheduleMissing:
          'ข้อมูลปฏิทินกะของพนักงานไม่ครบหรือขัดแย้งกัน กรุณาติดต่อฝ่ายบุคคล',
        birthdayMissing:
          'ไม่มีข้อมูลวันเกิดที่จำเป็น กรุณาให้ฝ่ายบุคคลตรวจสอบข้อมูลพนักงานหรือครอบครัว',
        birthdayMonth:
          'ช่วงวันลาทั้งรายการต้องอยู่ในเดือนเกิดที่ใช้สิทธิ์ได้เดือนเดียวกัน',
        periodYear: 'กรุณาเลือกวันที่ภายในปีของสิทธิ์การลานี้',
        invalidDate: 'กรุณาตรวจสอบวันที่เริ่มต้นและวันที่สิ้นสุด',
        blockLeaveUnavailable:
          'วันที่เลือกไม่ตรงตามเงื่อนไข Block Leave กรุณาปรับวันที่หรือยกเลิกตัวเลือก Block Leave',
        restrictedDate: 'วันที่เลือกไม่ตรงตามเงื่อนไขช่วงเวลาที่อนุญาตให้ลา',
        emptyCharge:
          'รายการลาต้องมีเวลาที่นับเป็นการลาตามเงื่อนไขของประเภทลานี้',
        invalidLimits:
          'จำนวนชั่วโมงทำงานหรือเพดานต่อรายการไม่ถูกต้อง กรุณาติดต่อฝ่ายบุคคล',
        maxPerRequest: 'จำนวนวันที่นับลาเกินเพดานสูงสุดต่อรายการ'
      },
      approvers: {
        loading: 'กำลังโหลดรายชื่อผู้อนุมัติ…',
        failed: 'ไม่สามารถโหลดรายชื่อผู้อนุมัติได้ กรุณาลองใหม่'
      },
      hour: {
        nextDay: 'สิ้นสุดวันถัดไป: {{date}}',
        equalTime: 'เวลาเริ่มและเวลาสิ้นสุดต้องไม่เท่ากัน',
        crossYear: 'การลาชั่วโมงต้องไม่ข้ามปี',
        incomplete: 'เลือกประเภทการลา วันที่ และเวลาเริ่ม/สิ้นสุดให้ครบ',
        loading: 'กำลังคำนวณเวลาลา…',
        charged: 'ยอดตัดสิทธิ์: {{minutes}} นาที',
        details:
          'ระยะเวลา {{gross}} − พัก {{rest}} = สุทธิ {{net}} นาที; ปรับเวลาต่อเนื่อง +{{adjustment}} นาที',
        remaining: 'เพดานคงเหลือในกะหลังรายการนี้: {{minutes}} นาที'
      },
      titles: {
        add: 'เพิ่ม',
        view: 'ดูรายละเอียดการขอลา',
        edit: 'แก้ไขรายละเอียดการขอลา'
      },
      words: {
        requester: 'Requester',
        'agent-requester': 'Agent Request',
        days: 'Days',
        total: 'รวมทั้งหมด',
        selectDate: 'เลือกวันที่',
        selectTime: 'เวลาที่เริ่ม'
      },
      fields: {
        leaveType: 'ประเภทการลา',
        leavePeriod: 'รอบการลา',
        emergencyLeave: '',
        emergencyLeaveLabel: 'ลาฉุกเฉิน',
        fromDate: 'ตั้งแต่วันที่',
        toDate: 'ถึงวันที่',
        startTime: 'เวลาที่เริ่ม',
        endTime: 'เวลาที่สิ้นสุด',
        leaveReason: 'เหตุผลการลา',
        reason: 'เหตุผล',
        attachFile: 'ไฟล์แนบ (จำกัด 3 ไฟล์และไม่ซ้ำ)',
        approver: 'ผู้อนุมัติ',
        status: 'สถานะ',
        'request-status': 'สถานะรายการลา',
        'please-upload-file': 'Please upload file',
        'employees-name': 'Employee Name',
        'hr-admin-name': 'HR Admin Name',
        'over-date': 'To date must be after from date',
        'over-time': 'End time must be after time date'
      },
      buttons: {
        submit: 'บันทึก',
        cancel: 'ยกเลิก'
      },
      'error-message': {
        '001': `บันทึกล้มเหลว เนื่องจากช่วงวันที่ลาอยู่ระหว่างปี`
      }
    }
  },
  history: {
    'filter-form': {
      organization: {
        placeholder: 'ชื่อองค์กร..',
        label: 'ชื่อองค์กร'
      },
      'employee-code': {
        placeholder: 'รหัสพนักงาน..',
        label: 'รหัสพนักงาน'
      },
      'name-surname': {
        placeholder: 'ชื่อ-สกุล..',
        label: 'ชื่อ-สกุล'
      },
      position: {
        placeholder: 'ตำแหน่ง..',
        label: 'ตำแหน่ง'
      },
      level: {
        placeholder: 'ระดับงาน..',
        label: 'ระดับงาน'
      },
      status: {
        placeholder: 'สถานะ..',
        label: 'สถานะ'
      },
      'leave-status': {
        placeholder: 'สถานะการลา..',
        label: 'สถานะการลา'
      },
      date: {
        placeholder: 'วัน..',
        label: 'วัน',
        dateRange: {
          placeholder: {
            formDate: 'ตั้งแต่วันที่',
            toDate: 'ถึงวันที่'
          }
        }
      },
      'leave-type': {
        placeholder: 'เลือกทั้งหมด',
        label: 'ประเภทการลา'
      }
    },
    table: {
      name: 'ชื่อ-สกุล',
      type: 'ประเภทการลา',
      duration: 'ระยะเวลาวันที่ลา',
      days: 'จำนวนวันลา',
      status: 'สถานะ',
      approval: 'ผู้อนุมัติ',
      attach: 'ไฟล์แนบ',
      action: 'ดำเนินการ'
    },
    modal: {
      cancelFailed: 'ยกเลิกรายการลาไม่สำเร็จ กรุณาลองใหม่',
      cancel: 'คุณต้องการยกเลิกรายการที่เลือกหรือไม่',
      resent: 'คุณต้องการส่งอีเมลอีกครั้งหรือไม่?',
      buttons: {
        yes: 'ใช่',
        no: 'ไม่'
      }
    }
  }
}
